module.exports = __webpack_public_path__ + "static/img/whatsup.d1068be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/whatsup.png
// module id = olut
// module chunks = 0